// extracted by mini-css-extract-plugin
export default {"item":"DocumentCell_item__8tke6","btn_container":"DocumentCell_btn_container__lari9"};